import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Flex, TextButton, useOpenModal } from '@modusign/design-system';
import isEqual from 'lodash/isEqual';
import { useState } from 'react';

import { UseSelectionMapReturn } from '@hooks';

import { useLabelChangeContext } from '@app/features/label/components/LabelPopovers/context/LabelChanges';
import {
  LabelingState,
  LabelsLabelingState,
} from '@app/features/label/components/LabelPopovers/context/types';

import LabelCreationModal from '../../../LabelCreationModal';

interface LabelSelectModalFooterProps {
  initialLabeled: LabelsLabelingState;
  mode: 'infinite' | 'limit';
  selected: UseSelectionMapReturn<LabelingState>;
  onSubmit: (labelChanges: Array<{ labelId: string; apply: boolean }>) => void | Promise<unknown>;
}

function LabelSelectModalFooter({
  initialLabeled,
  mode,
  selected: { entries },
  onSubmit,
}: LabelSelectModalFooterProps) {
  const openModal = useOpenModal();
  const isSelectNothing = isEqual(
    initialLabeled,
    Object.fromEntries(entries.filter(([, v]) => v !== 'NONE'))
  );

  const { labelChangesMap } = useLabelChangeContext();
  const changeValues = Array.from(labelChangesMap.entries());

  const [isLoading, setIsLoading] = useState(false);

  return (
    <Flex alignItems="center" as="section" justifyContent={['end', 'space-between']} p={4}>
      <TextButton
        display={['none', 'block', 'block']}
        fontSize="md"
        fontWeight="medium"
        onClick={() => {
          openModal(({ onClose }) => <LabelCreationModal onCancel={onClose} onCreated={onClose} />);
        }}
      >
        <Box as={FontAwesomeIcon} fontSize="12px" icon={faPlus} />새 라벨
      </TextButton>
      <Button
        disabled={mode === 'infinite' ? changeValues.length === 0 : isSelectNothing}
        isLoading={isLoading}
        px={5}
        py={2}
        variant="primary"
        weight="light"
        onClick={async () => {
          try {
            setIsLoading(true);
            await onSubmit(
              mode === 'infinite'
                ? changeValues.map(([labelId, target]) => ({
                    labelId,
                    apply: target === 'ALL',
                  }))
                : entries.map(([labelId, target]) => ({
                    labelId,
                    apply: target === 'ALL',
                  }))
            );
          } finally {
            setIsLoading(false);
          }
        }}
      >
        적용
      </Button>
    </Flex>
  );
}

export default LabelSelectModalFooter;
